import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";

import styles from'./styles.scss';

import { useDispatch } from "react-redux"
import { 
    showMsgW as showMsgWAction,
    showMsgE as showMsgEAction,
    showMsgS as showMsgSAction,
} from '../../store/actions/snackbarActions.js';

import services from '../../services';
import MeusDados from './MeusDados';
import { getParticipanteById } from '../../services/api-auto'
import ModalLoading from '../../components/ModalLoading';

const formCadastroInitialState = { 
  email: "",
  nome: "",
  phoneNumber: "",
  userName: "",

  roleId: "",

  cnpjUsuario: "",
  razaoSocialUsuario: "",

  cep1: "",
  logradouro1: "",
  numero1: "",
  complemento1: "",
  bairro1: "",
  uf1: "",
  cidade1: "",
  mesmoEnderecoEntrega: true,
  cep2: "",
  logradouro2: "",
  numero2: "",
  complemento2: "",
  bairro2: "",
  uf2: "",
  cidade2: "",
  perfilAcesso: 0,

  senha: "",
  senhaConfirmar: "",
}

const MeuCadastro = props => {
  const history = useHistory();
  const dispatch = useDispatch();
  const showMsgW = (msg) => dispatch(showMsgWAction(msg));
  const showMsgE = (msg) => dispatch(showMsgEAction(msg));
  const showMsgS = (msg) => dispatch(showMsgSAction(msg));

  const [formCadastro, setFormCadastro] = useState({...formCadastroInitialState});
  const [indicarErrosCadastro, setIndicarErrosCadastro] = useState(false);
  const [parceiroId, setParceiroId] = useState("");
  const [participanteId, setParticipanteId] = useState("");
  const [loading, setLoading] = useState(false)

  const handleChangeForm = (value, campo) => {
    setFormCadastro( prevstate => ({...prevstate, [campo]: value }) )
  }

  const salvar = () => {
    if(validarForm()) { 
      editar()
    }
  }

  const getParticipante = async(parceiro, participante) => {
    try{
      setLoading(true)
      const info = await getParticipanteById(participante)
      const newForm = { 
        parceiroId: parceiro,
        cidade1: info.data.cidade1?.cidadeId, 
        cidade2: info.data.cidade2?.cidadeId, 
        uf1: info.data.uf1?.ufId, 
        uf2: info.data.uf2?.ufId, 
        userId: info.data.userId,

        bairro1: info.data.bairro1,
        bairro2: info.data.bairro2,
        email: info.data.email,
        cep1: info.data.cep1,
        cep2: info.data.cep2,
        complemento1: info.data.complemento1,
        complemento2: info.data.complemento2,
        logradouro1: info.data.logradouro1,
        logradouro2: info.data.logradouro2,
        nome: info.data.nome,
        numero1: info.data.numero1,
        numero2: info.data.numero2,
        phoneNumber: info.data.phoneNumber,
        userName: info.data.userName,

        roleId: info.data.role.displayName,
        cnpjUsuario: info.data.cnpj,
        razaoSocialUsuario: info.data.razaoSocial,
        mesmoEnderecoEntrega: info.data.mesmoEnderecoEntrega,
        perfilAcesso: 0,
        senha: "",
        senhaConfirmar: "",
      }
      setFormCadastro(newForm)
      
    }catch(e){
      showMsgE("Não foi possível carregar os dados")
    }finally{
      setLoading(false)
    }
    
  }

  useEffect( ()=>{
    const parceiro = new URLSearchParams(history.location.search).get('parceiro');
    setParceiroId(parceiro)
    const participante = new URLSearchParams(history.location.search).get('participante');
    setParticipanteId(participante)


    if(parceiro){
      if(participante){
        getParticipante(parceiro, participante)
      }else{
        setFormCadastro({ ...formCadastro, parceiroId: parceiro })
      }
    } else {
      history.goBack();
    }
  },[] )

  const editar = async () => {

    let objEnvio = {
      parceiroId: formCadastro.parceiroId,
      nomeCompleto: formCadastro.nome,
      cpf: services.mask.unMask(formCadastro.userName),
      email: formCadastro.email,
      phoneNumber: services.mask.unMask( formCadastro.phoneNumber ),
      cargo: formCadastro.roleId,
      cep: services.mask.unMask(formCadastro.cep1),
      cidade1: {
        cidadeId: formCadastro.cidade1,
      },
      bairro: formCadastro.bairro1,
      logradouro: formCadastro.logradouro1,
      numero: formCadastro.numero1,
      complemento: formCadastro.complemento1,
      usarEnderecoEntrega: formCadastro.mesmoEnderecoEntrega,
      }

    if(!formCadastro.mesmoEnderecoEntrega){
      objEnvio.cep2 = services.mask.unMask(formCadastro.cep2);
      objEnvio.cidade2 = {
        cidadeId: formCadastro.cidade2
      };
      objEnvio.bairro2 = formCadastro.bairro2;
      objEnvio.logradouro2 = formCadastro.logradouro2;
      objEnvio.numero2 = formCadastro.numero2;
      objEnvio.complemento2 = formCadastro.complemento2;
    }
    if(formCadastro.userId){
      objEnvio.userId = formCadastro.userId;
    }

    if (formCadastro.senha) {
        objEnvio.senha = formCadastro.senha;
        objEnvio.confirmaSenha = formCadastro.senhaConfirmar;
    }

    try{
      setLoading(true)
        await services.apiAuto.postParticipantes(objEnvio) 
      showMsgS("Dados salvos com sucesso")
      setTimeout(()=>{
        history.goBack()
      }, 2000)
    }catch(e){
      showMsgE(e.response.data)
    }finally{
      setLoading(false)
    }
  }

  const validarForm = () => {
    let valid = true
    let msg = ''
    if(
      !formCadastro.nome ||
      !formCadastro.phoneNumber ||
      !formCadastro.roleId ||
      !formCadastro.email ||
      !formCadastro.userName
    ) { msg = 'Informe os campos obrigatórios'; valid = false; }
    if (!services.validate.valideCellphone( services.mask.unMask(formCadastro.phoneNumber) ) ) { msg = 'Informe um número de celular válido'; valid = false; }
    if (!services.validate.valideCpf(services.mask.unMask(formCadastro.userName))) { msg = 'Informe um CPF válido'; valid = false;}
    if (!services.validate.valideMail(formCadastro.email)) { msg = 'Informe um E-mail válido'; valid = false; }
    
    if(formCadastro.senha){
      if (!services.validate.validePasswordSize(formCadastro.senha)) { msg = 'Senha deve ter mínimo 8 caracteres'; valid = false; }
      if (!services.validate.validePasswordNumber(formCadastro.senha)) { msg = 'Senha deve ter ao menos 1 número'; valid = false; }
      if (!services.validate.validePasswordCapital(formCadastro.senha)) { msg = 'Senha deve ter letras maiúsculas e minúsculas'; valid = false; }
      if (!services.validate.validePasswordSpecial(formCadastro.senha)) { msg = 'Senha deve ter caracteres especiais'; valid = false; }
      if (formCadastro.senha !== formCadastro.senhaConfirmar) { msg = 'Senha e Confirme sua senha devem ser iguais'; valid = false; }
    }
    // if(!formCadastro.mesmoEnderecoEntrega) {if(!formCadastro.cep2) { msg = 'informe um novo CEP valido'; valid = false; }}
    // if(!formCadastro.mesmoEnderecoEntrega) {if(!formCadastro.logradouro2) { msg = 'informe um novo logradouro valido'; valid = false; }}
    // if(!formCadastro.mesmoEnderecoEntrega) {if(!formCadastro.numero2) { msg = 'informe um novo número valido'; valid = false; }}
    // if(!formCadastro.mesmoEnderecoEntrega) {if(!formCadastro.bairro2) { msg = 'informe um novo bairro valido'; valid = false; }}
    // if(!formCadastro.mesmoEnderecoEntrega) {if(!formCadastro.uf2) { msg = 'informe um novo UF valido'; valid = false; }}
    // if(!formCadastro.mesmoEnderecoEntrega) {if(!formCadastro.cidade2) { msg = 'informe uma nova cidade válida'; valid = false; }}

    if (msg) { 
      showMsgW(msg) 
    } else {
      if (!valid) showMsgW('Informe todos os campos obrigatórios') 
    }
    return valid
  }

  return (
    <div className={styles.wrapper}>
      {/* <h1 className='container'>Participante</h1> */}
      <MeusDados 
       formPage={formCadastro}
       action={salvar}
       changes={handleChangeForm}
       indicarErros={indicarErrosCadastro}
      />
      <ModalLoading open={loading} />
    </div>
  );
  
}

export default MeuCadastro;